<template>
  <div class="app-skip-nav">
    <a :href="`${$route.path}#mainContent`">Skip to main content</a>
  </div>
</template>

<script setup>
// The $route variable is accessible in the template without importing useRoute.
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/skip-nav";
</style>
